/* @flow */
/** @jsx h */
import { h, Component } from 'preact';
import cssStyle from './index.css';
import cn from 'classnames';
import { hexToRGBA } from '../../js/colors';

type PropTypes = {
  message: string;
  name: string;
  confirm: string;
  cancel: string;
  onConfirm: (e: Event, duration: number) => void;
  onCancel: (e: Event, duration: number) => void;
  onClick: (e: Event) => void;
  position: 'center' | 'top' | 'bottom';
  backgroundColor?: string;
  backgroundOpacity?: number;
  skOverlayIsOpened?: boolean;
};
export default class ConfirmOverlay extends Component<PropTypes> {
  state: { displayedAt: number };

  constructor(props: PropTypes) {
    super(props);

    this.state = { displayedAt: 0 };
  }

  componentDidMount() {
    this.setState({
      displayedAt: Date.now()
    });
  }

  render() {
    const {
      message,
      confirm,
      cancel,
      onConfirm,
      onCancel,
      position = 'center',
      backgroundColor = '#888888',
      backgroundOpacity = 60,
      skOverlayIsOpened
    } = this.props;

    const modalStyles: h.JSX.CSSProperties = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: hexToRGBA(
        backgroundColor,
        backgroundOpacity / 100
      ) as string,
      pointerEvents: 'auto'
    };

    const layerDataZone = this.props.name + '_layer';
    const skipDataZone = this.props.name + '_skip_button';
    const continueDataZone = this.props.name + '_continue_button';

    return (
      <div
        className={cssStyle.dualButtonModal}
        style={modalStyles}
        data-zone={layerDataZone}
        onClick={e => this.props.onClick(e)}
      >
        <div
          className={cn({
            [cssStyle.dialogTop]: position === 'top',
            [cssStyle.dialogBottom]: position === 'bottom',
            [cssStyle.dialogBottomWithSKOverlay]:
              position === 'bottom' && skOverlayIsOpened,
            [cssStyle.dialogBottomWithoutSKOverlay]:
              position === 'bottom' && !skOverlayIsOpened,
            [cssStyle.dialog]: true
          })}
        >
          <div className={cssStyle.label} id="message">
            {message}
          </div>
          <div className={cssStyle.buttonsContainer}>
            <button
              id="continue"
              data-zone={continueDataZone}
              className={cssStyle.continue}
              onClick={e => {
                onCancel(
                  e,
                  Math.round((Date.now() - this.state.displayedAt) / 1000)
                );
              }}
            >
              {cancel}
            </button>
            |
            <button
              id="skip"
              aria-label="ogury_skip_button"
              data-zone={skipDataZone}
              className={cssStyle.skip}
              onClick={e => {
                onConfirm(
                  e,
                  Math.round((Date.now() - this.state.displayedAt) / 1000)
                );
              }}
            >
              {confirm}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
